<template>
	<div class="intellectual-banner">
		<div class="intellectual-banner.form">
			<h2>购买商标快捷登记<small>10分钟为您快速匹配商标</small></h2>
			<el-form :model="bannerForm" :rules="bannerRules" ref="bannerForm" label-width="100px" class="demo-ruleForm">
				<el-form-item prop="content">
					<el-input v-model="bannerForm.content" placeholder="对商标的要求"></el-input>
				</el-form-item>
				<el-form-item prop="phone">
					<el-input v-model="bannerForm.phone" placeholder="您的联系方式"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="submitForm('bannerForm')">立即登记</el-button>
				</el-form-item>
			</el-form>
			<section>
				<h4>最新求购需求</h4>
				<vueSeamlessScroll :data="needLists" :class-option="defaultOption" class="seamless-warp">
					<ul class="item">
						<li v-for="(item, index) in needLists" :key='index'>
							<span class="title">{{item.phone.substring(0,3)+"****"+ item.phone.substring(8,11)}}</span><span class="date">{{item.content}}</span>
						</li>
					</ul>
				</vueSeamlessScroll>


			</section>
		</div>

	</div>
</template>

<script>
	import vueSeamlessScroll from 'vue-seamless-scroll'
	import '../fetch/formatDate';
	import checkPhone from '../fetch/checkPhone';
	export default {
		components: {
			vueSeamlessScroll
		},

		computed: {
			// 公告滚动自定义
			defaultOption() {
				return {
					step: 0.2, // 数值越大速度滚动越快
					limitMoveNum: 3, // 开始无缝滚动的数据量 this.dataList.length
					hoverStop: true, // 是否开启鼠标悬停stop
					direction: 1, // 0向下 1向上 2向左 3向右
					openWatch: true, // 开启数据实时监控刷新dom
					singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
					singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
					waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
				}
			}
		},
		data() {
			return {
				needLists: [{
						phone: '183****0213',
						desc: '求购11类电器商标'
					},
					{
						phone: '193****0213',
						desc: '20类家具商标'
					},
					{
						phone: '156****0213',
						desc: '欧美范儿'
					},
				],
				bannerForm: {
					content: '',
					phone: '',
					type:4, //商标快捷登记
					name:'商标快捷登记测试人员',
					date_time: new Date().format("yyyy-MM-dd hh:mm:ss")
				},
				bannerRules: {
					content: [{
						required: true,
						message: '请填写商标要求',
						trigger: 'blur'
					}],
					phone: [
						{validator: checkPhone, trigger: 'blur'}
					]

				}
			}
		},
		methods: {
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.http.post('IPR_Need',this.bannerForm).then(res => {
							if(res.code == 0){
								this.$emit('showTipsEvent', true)
							    this.$refs[formName].resetFields();
							}
						})
						//this.$emit('showTipsEvent', true)
						//this.$refs[formName].resetFields();
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			initNeeds(){
				this.http.get("IPR_Need?type=4").then(res => {
					this.needLists = res.data.data
				})
			}

		},
		mounted(){
			this.initNeeds()
		}
	}
</script>

<style lang="scss">
	@include component(intellectual-banner) {
		width: 1200px;
		height: 100%;
		position: relative;
		margin: 0 auto;
		//background: red;

		@include part(form) {
			width: 300px;
			height: 400px;
			position: absolute;
			right: 0;
			top: 60px;
			background: #fff;
			padding: 30px 20px;
			color: #333333;
			border-radius: 5px;

			h2 {
				font-size: 20px;
				margin: 0;
				margin-bottom: 5px;

				small {
					display: block;
					font-size: 14px;
					color: #999999;
					font-weight: normal;
				}
			}

			h4 {
				margin: 0;
				font-size: 16px;
				position: relative;
				margin-bottom:8px;

				&:before,
				&:after {
					content: '';
					display: inline-block;
					width: 70px;
					height: 1px;
					background: #CCCCCC;
					position: absolute;
					top: 10px;
				}

				&:before {
					left: 0;
				}

				&:after {
					right: 0;
				}
			}

			>section {
				height: 110px;
				ul {
					width: 100%;
					height: 100%;
					

					li {
						font-size: 14px;
						color: #999;
						width: 100%;
						display: flex;
						align-items: center;
						justify-content: space-between;

						&:not(:nth-child(1)) {
							//margin-top: 5px;
						}

						span {
							display: inline-block;
							width: 50%;
							text-align: left;
							&.date{
								overflow: hidden;
								text-overflow: ellipsis;
								white-space: nowrap;
							}
						}
					}
				}
			}
			@include component(el-form-item){
				margin-bottom: 14px;
			}
			@include component(el-form-item__error){
				padding: 0
			}

			@include component(el-form-item__content) {
				margin-left: 0 !important;
			}

			@include component(el-form) {
				padding-top: 15px;


			}

			@include component(el-button) {
				width: 100%;
				background: #F47227;
				border: none;
				margin-top: 10px;
			}

			@include component(el-button--primary) {
				background-color: #F47227;

				&:active,
				&:hover,
				&:focus {
					background-color: #F47227;
				}

				&.is-active {
					background-color: #F47227;
				}
			}
		}
		.seamless-warp {
			height: 70%;
			overflow: hidden;
		}
	}
</style>
